<section class="container p-0 p-md-5">
    <div class=" grid-shadow1 p-4">
        <div class="row">
            <div class="col-md-12 mb-3 ">
                <h4 class="text-center heading1">Quotation Number : {{quotesInfo?.QuotationNumber}}</h4>
                <hr>
                <div class="d-flex justify-content-between mt-3">
                    <div class="back-button mb-3">
                        <span class="back-icon" (click)="goBack()"><i class="fa-solid fa-arrow-left"></i></span>
                        <h4 class="back-button-heading mx-3">Proposal Form</h4>
                    </div>
                </div>
                <!-- <div class="show-on-small-screen">
                <h4 class="back-button-heading"><span class="quotation-info-card-title">(<strong>Quotation ID :</strong> QA0000123982)</span></h4>
              </div> -->
                <!-- <section class="my-4">
                <span class="quotation-info-card px-4 py-2 ">
                    <span class="quotation-info-card-title"><strong>Quotation ID :</strong> QA0000123982</span>
                  </span>
            </section> -->

                <section class="my-4">
                    <form [formGroup]="proposalForm">
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Product Name <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="productName">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('productName')?.invalid && (proposalForm.get('productName')?.dirty || proposalForm.get('productName')?.touched) && proposalForm.get('productName')?.errors?.['required']">
                                    Product Name is required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Premium Amount <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="premiumAmount">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('premiumAmount')?.invalid && (proposalForm.get('premiumAmount')?.dirty || proposalForm.get('premiumAmount')?.touched) && proposalForm.get('premiumAmount')?.errors?.['required']">
                                    Premium Amount is required.
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="field-label">Destination(s) <span class="text-red small">*</span></label>
                            <div class="">
                                <mat-form-field class="example-chip-list w-100">
                                    <mat-chip-grid #chipGrid aria-label="Destination selection w-100"
                                        formControlName="destination">
                                        <mat-chip-row *ngFor="let destination of selectedDestinations"
                                            (removed)="remove(destination)">
                                            {{destination.ToCountryName}}
                                            <button matChipRemove
                                                [attr.aria-label]="'remove ' + destination.ToCountryName">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    </mat-chip-grid>

                                    <input #destinationInput (focus)="onFocus()" [matChipInputFor]="chipGrid"
                                        [matAutocomplete]="auto" />
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
                                        <mat-option *ngFor="let destination of filteredDestinations | async"
                                            [value]="destination.TocountryID">
                                            {{destination.ToCountryName}}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <div class="text-red small" *ngIf="(proposalForm.get('destination')?.dirty || proposalForm.get('destination')?.touched) && selectedDestinations.length==0">
                                    Destination is required.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Trip Start Date <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100">
                                    <input matInput [matDatepicker]="tripStartDate" formControlName="tripStartDate"
                                        placeholder="DD/MM/YYYY">
                                    <mat-datepicker-toggle matIconSuffix [for]="tripStartDate"></mat-datepicker-toggle>
                                    <mat-datepicker #tripStartDate></mat-datepicker>
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('tripStartDate')?.invalid && (proposalForm.get('tripStartDate')?.dirty || proposalForm.get('tripStartDate')?.touched) && proposalForm.get('tripStartDate')?.errors?.['required']">
                                    Trip Start Date is required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Trip End Date <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100">
                                    <input matInput [matDatepicker]="tripEndDate" [min]="minTripEndDate"
                                        formControlName="tripEndDate" placeholder="DD/MM/YYYY">
                                    <mat-datepicker-toggle matIconSuffix [for]="tripEndDate"></mat-datepicker-toggle>
                                    <mat-datepicker #tripEndDate></mat-datepicker>
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('tripEndDate')?.invalid && (proposalForm.get('tripEndDate')?.dirty || proposalForm.get('tripEndDate')?.touched) && proposalForm.get('tripEndDate')?.errors?.['required']">
                                    Trip End Date is required.
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Traveling Days <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" (keypress)="numberOnly($event)"
                                        formControlName="travelingDays">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('travelingDays')?.invalid && (proposalForm.get('travelingDays')?.dirty || proposalForm.get('travelingDays')?.touched) && proposalForm.get('travelingDays')?.errors?.['required']">
                                    Traveling Days is required.
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Number of Travelers <span
                                        class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="numberOfTravelers"
                                        (keypress)="numberOnly($event)" (blur)="numberOfTravelers()">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('numberOfTravelers')?.invalid && (proposalForm.get('numberOfTravelers')?.dirty || proposalForm.get('numberOfTravelers')?.touched) && proposalForm.get('numberOfTravelers')?.errors?.['required']">
                                    Number of Travelers is required.
                                </div>
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="field-label">KRA Pin Type<span class="text-red small">*</span></label>
                            <div>
                              <mat-radio-group formControlName="kraPinType">
                                <mat-radio-button *ngFor="let kRAPintype of kRAPintypeList" [value]="kRAPintype.masterDataID">
                                  {{ kRAPintype.mdTitle }}
                                </mat-radio-button>
                              </mat-radio-group>
                            </div>
                            <div class="text-red small"
                            *ngIf="proposalForm.get('kraPinType')?.invalid && (proposalForm.get('kraPinType')?.dirty || proposalForm.get('kraPinType')?.touched) && proposalForm.get('kraPinType')?.errors?.['required']">
                            KRA Pin Type is required.
                        </div>
                          </div>

                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">KRA Pin Number <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" 
                                        formControlName="kraPinNumber">
                                </mat-form-field>
                                <div class="form-text">
                                    Ex:A123456789X
                                  </div>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('kraPinNumber')?.invalid && (proposalForm.get('kraPinNumber')?.dirty || proposalForm.get('kraPinNumber')?.touched) && proposalForm.get('kraPinNumber')?.errors?.['required']">
                                    KRA Pin Number is required.
                                </div>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('kraPinNumber')?.invalid && (proposalForm.get('kraPinNumber')?.dirty || proposalForm.get('kraPinNumber')?.touched) && proposalForm.get('kraPinNumber')?.errors?.['invalidKraPinNumber']">
                                    KRA Pin Number is invalid.
                                </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Insured's Occupation <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" 
                                        formControlName="insuredOccupation">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('insuredOccupation')?.invalid  && (proposalForm.get('insuredOccupation')?.dirty || proposalForm.get('insuredOccupation')?.touched) && proposalForm.get('insuredOccupation')?.errors?.['required']">
                                    Insured's Occupation is required.
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Beneficiary Name<span
                                    class="text-red small">*</span></label>
                            <mat-form-field class="w-100 mat-form-field-sm">
                                <input matInput type="text" formControlName="beneficiaryName">
                            </mat-form-field>
                            <div class="text-red small"
                            *ngIf="proposalForm.get('beneficiaryName')?.invalid  && (proposalForm.get('beneficiaryName')?.dirty || proposalForm.get('beneficiaryName')?.touched) && proposalForm.get('beneficiaryName')?.errors?.['required']">
                            Beneficiary Name is required.
                        </div>
                            </div>
                            <div class="col-md-6 mb-2">
                                <label class="field-label">Beneficiary Mobile Number <span
                                    class="text-red small">*</span></label>
                            <mat-form-field class="w-100 mat-form-field-sm">
                                <input matInput (keypress)="numberOnly($event)" type="text"
                                    formControlName="beneficiaryTelephoneNo">
                            </mat-form-field>
                            <div class="text-red small"
                            *ngIf="proposalForm.get('beneficiaryTelephoneNo')?.invalid  && (proposalForm.get('beneficiaryTelephoneNo')?.dirty || proposalForm.get('beneficiaryTelephoneNo')?.touched) && proposalForm.get('beneficiaryTelephoneNo')?.errors?.['required']">
                            Beneficiary Mobile Number is required.
                        </div>
                        <div class="text-red small"
                        *ngIf="proposalForm.get('beneficiaryTelephoneNo')?.invalid  && (proposalForm.get('beneficiaryTelephoneNo')?.dirty || proposalForm.get('beneficiaryTelephoneNo')?.touched)  && proposalForm.get('beneficiaryTelephoneNo')?.errors?.['minlength']">
                        Beneficiary Mobile Number should be at least 9 digits long.
                    </div>
                    <div class="text-red small"
                        *ngIf="proposalForm.get('beneficiaryTelephoneNo')?.invalid  && (proposalForm.get('beneficiaryTelephoneNo')?.dirty || proposalForm.get('beneficiaryTelephoneNo')?.touched)  && proposalForm.get('beneficiaryTelephoneNo')?.errors?.['maxlength']">
                        Beneficiary Mobile Number should not exceed 9 digits.
                    </div>
                            </div>
                        </div>
                        <!-- <div>
                            <label class="field-label">Postal Address<span class="text-red small">*</span></label>
                            <mat-form-field class="w-100 example-full-width">
                                <textarea matInput formControlName="postalAddress"></textarea>
                              </mat-form-field>
                              <div class="text-red small"
                                    *ngIf="proposalForm.get('postalAddress')?.invalid  && (proposalForm.get('postalAddress')?.dirty || proposalForm.get('postalAddress')?.touched) && proposalForm.get('postalAddress')?.errors?.['required']">
                                    Postal Address is required.
                                </div>
                        </div> -->
                        <section formGroupName="address">
                            <div class="heading2 mt-4 mb-2">Postal Address</div>
                            <div class="mb-2">
                                <label class="field-label">House Number <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="houseNumber">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('address.houseNumber')?.invalid  && (proposalForm.get('address.houseNumber')?.dirty || proposalForm.get('address.houseNumber')?.touched) && proposalForm.get('address.houseNumber')?.errors?.['required']">
                                    House Number is required.
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="field-label">Road Name <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="roadName">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('address.roadName')?.invalid  && (proposalForm.get('address.roadName')?.dirty || proposalForm.get('address.roadName')?.touched) && proposalForm.get('address.roadName')?.errors?.['required']">
                                    Road Name is required.
                                </div>
                            </div>
                            <div class="mb-2">
                                <label class="field-label">Pincode <span class="text-red small">*</span></label>
                                <mat-form-field class="w-100 mat-form-field-sm">
                                    <input matInput type="text" formControlName="pincode"
                                        (keypress)="numberOnly($event)">
                                </mat-form-field>
                                <div class="text-red small"
                                    *ngIf="proposalForm.get('address.pincode')?.invalid  && (proposalForm.get('address.pincode')?.dirty || proposalForm.get('address.pincode')?.touched) && proposalForm.get('address.pincode')?.errors?.['required']">
                                    Pincode is required.
                                </div>
                            </div>
                        </section>



                        <section class="mt-4" formArrayName="travelersDetails">
                            <div class="heading1 mb-4">Traveler Details</div>
                            <div *ngFor="let travelerDetail of getTravelersDetails.controls; let i = index"
                                [formGroupName]="i">
                                <div class="heading2">
                                    Traveler {{i + 1}}
                                    <section class="example-section d-inline">
                                        <mat-checkbox formControlName="isProposerATraveller"
                                            (change)="onProposerChange(travelerDetail, $event.checked)">Is the Proposer?
                                        </mat-checkbox>
                                    </section>
                                </div>
                                <div class="row">
                                    <!-- <div class="col-md-4 mb-2">
                                    <label class="field-label">Title </label>
                                    <mat-form-field>
                                        <mat-select formControlName="title">
                                            <mat-option value="option1">Mr</mat-option>
                                            <mat-option value="option2">Mrs</mat-option>
                                            <mat-option value="option3">others</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div> -->
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">First Name <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="firstName">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('firstName')?.invalid  && (getTravelersDetails.at(i).get('firstName')?.dirty || getTravelersDetails.at(i).get('firstName')?.touched) && getTravelersDetails.at(i).get('firstName')?.errors?.['required']">
                                            First Name is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Last Name <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="lastName">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('lastName')?.invalid && (getTravelersDetails.at(i).get('lastName')?.dirty || getTravelersDetails.at(i).get('lastName')?.touched)  && getTravelersDetails.at(i).get('lastName')?.errors?.['required']">
                                            Last Name is required.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Name as per the passport <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="nameAsPerThePassport">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('nameAsPerThePassport')?.invalid  && (getTravelersDetails.at(i).get('nameAsPerThePassport')?.dirty || getTravelersDetails.at(i).get('nameAsPerThePassport')?.touched)  && getTravelersDetails.at(i).get('nameAsPerThePassport')?.errors?.['required']">
                                            Name as per the passport is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Email ID <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="email" formControlName="emailId">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('emailId')?.invalid  && (getTravelersDetails.at(i).get('emailId')?.dirty || getTravelersDetails.at(i).get('emailId')?.touched) && getTravelersDetails.at(i).get('emailId')?.errors?.['required']">
                                            Email ID is required.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('emailId')?.invalid  && (getTravelersDetails.at(i).get('emailId')?.dirty || getTravelersDetails.at(i).get('emailId')?.touched)  && getTravelersDetails.at(i).get('emailId')?.errors?.['email']">
                                            Enter valid email.
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Date of Birth <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <input matInput [matDatepicker]="picker" [max]="dateOfBirthMaxDate"
                                                formControlName="dateOfBirth" placeholder="DD/MM/YYYY"
                                                (dateChange)="dateOfBirthChange($event,i)">
                                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker #picker="matDatepicker"></mat-datepicker>
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('dateOfBirth')?.invalid  && (getTravelersDetails.at(i).get('dateOfBirth')?.dirty || getTravelersDetails.at(i).get('dateOfBirth')?.touched)  && getTravelersDetails.at(i).get('dateOfBirth')?.errors?.['required']">
                                            Date of Birth is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Age <span class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput (keypress)="numberOnly($event)" type="text"
                                                formControlName="age">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('age')?.invalid  && (getTravelersDetails.at(i).get('age')?.dirty || getTravelersDetails.at(i).get('age')?.touched)  && getTravelersDetails.at(i).get('age')?.errors?.['required']">
                                            Age is required.
                                        </div>
                                    </div>

                                </div>
                                <div class="row">
                                    <div class="col-md-4 mb-2">
                                        <label class="field-label">Country Code <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="mobileCode">
                                                <mat-option *ngFor="let code of countryCodes"
                                                    [value]="code.masterDataID">
                                                    <span> {{code.mdTitle}}</span>
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileCode')?.invalid  && (getTravelersDetails.at(i).get('mobileCode')?.dirty || getTravelersDetails.at(i).get('mobileCode')?.touched)  && getTravelersDetails.at(i).get('mobileCode')?.errors?.['required']">
                                            Country Code is required.
                                        </div>
                                    </div>
                                    <div class="col-md-8 mb-2">
                                        <label class="field-label">Mobile Number <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput (keypress)="numberOnly($event)" type="text"
                                                formControlName="mobileNumber">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['required']">
                                            Mobile Number is required.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['minlength']">
                                            Mobile number should be at least 9 digits long.
                                        </div>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('mobileNumber')?.invalid  && (getTravelersDetails.at(i).get('mobileNumber')?.dirty || getTravelersDetails.at(i).get('mobileNumber')?.touched)  && getTravelersDetails.at(i).get('mobileNumber')?.errors?.['maxlength']">
                                            Mobile number should not exceed 9 digits.
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Passport Number <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100 mat-form-field-sm">
                                            <input matInput type="text" formControlName="passportNumber">
                                        </mat-form-field>
                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('passportNumber')?.invalid  && (getTravelersDetails.at(i).get('passportNumber')?.dirty || getTravelersDetails.at(i).get('passportNumber')?.touched)  && getTravelersDetails.at(i).get('passportNumber')?.errors?.['required']">
                                            Passport Number is required.
                                        </div>
                                    </div>
                                    <div class="col-md-6 mb-2">
                                        <label class="field-label">Relationship with the proposer <span
                                                class="text-red small">*</span></label>
                                        <mat-form-field class="w-100">
                                            <mat-select formControlName="relationshipWithTheProposer">
                                                <ng-container *ngFor="let relationship of relationshipList">
                                                    <mat-option
                                                        *ngIf="(travelerDetail.get('isProposerATraveller')?.value && relationship.masterDataID=='eaf41d97-4dd2-4406-b351-5424e55507b2') || relationship.masterDataID!='eaf41d97-4dd2-4406-b351-5424e55507b2'"
                                                        [value]="relationship.masterDataID">
                                                        {{relationship.mdTitle}}
                                                    </mat-option>
                                                </ng-container>
                                            </mat-select>
                                        </mat-form-field>

                                        <div class="text-red small"
                                            *ngIf="getTravelersDetails.at(i).get('relationshipWithTheProposer')?.invalid && (getTravelersDetails.at(i).get('relationshipWithTheProposer')?.dirty || getTravelersDetails.at(i).get('relationshipWithTheProposer')?.touched)  && getTravelersDetails.at(i).get('relationshipWithTheProposer')?.errors?.['required']">
                                            Relationship with the proposer is required.
                                        </div>
                                    </div>

                                </div>

                                <div class="mb-2">
                                    <div class="mb-3">
                                        <label for="formFile" class="field-label">Upload Passport <span
                                                class="text-red small">*</span></label>
                                        <input class="form-control" type="file" accept="image/*"
                                            (change)="onFileSelected($event,i)" id="formFile"
                                            formControlName="passportFile">
                                        <div class="text-red small"
                                            *ngIf="submitted && getTravelersDetails.at(i).get('passportFileAttachmentID')?.invalid && getTravelersDetails.at(i).get('passportFileAttachmentID')?.errors?.['required']">
                                            Passport is required.
                                        </div>
                                    </div>
                                    <div class="mb-2"
                                    *ngIf="travelerDetail.get('passportFileAttachmentID')?.value!='00000000-0000-0000-0000-000000000000' && travelerDetail.get('passportFileAttachmentID')?.value">
                                    <div><a class="link" (click)="DownloadPassportCopy(i)">Download Passport <i
                                                class="fa-solid fa-download"></i></a> </div>
                                </div>
                                </div>
                            </div>
                        </section>
                        <div *ngIf="getTravelersDetails.controls.length>0  && (getTravelersDetails.dirty || getTravelersDetails.touched) && getTravelersDetails.hasError('minAgeRequired')">
                            <span class="text-red small">At least one traveler must be 3 years old.</span>
                          </div>
                        <section class="destination-section mb-3" formArrayName="declarationInfo">
                            <div class="d-flex align-items-center primary-heading mb-2">
                                <mat-checkbox class="ml-2" [formControl]="allDeclarationsControl"  (change)="selectAllDeclarations($event.checked)">
                                    <span class="primary-heading">DECLARATION (I/We declare that) :</span>  
                                  </mat-checkbox>
                                
                              </div>
                            <div class="example-section mb-2" *ngFor="let declaration of declarationList; let i = index">
                              <mat-checkbox class="example-margin" [formControlName]="i" (change)="updateAllDeclarationsSelected()">
                                {{declaration.mdTitle}}
                              </mat-checkbox>
                            </div>
                          </section>
                        <section class="consent-section"  formArrayName="consentInfo">
                            <div class="d-flex align-items-center primary-heading mb-2">
                                
                                <mat-checkbox class="ml-2" [formControl]="allConsentsControl" (change)="selectAllConsents($event.checked)">
                                    <span class="primary-heading">CONSENT  (I/We Consent that):</span>
                                  </mat-checkbox>
                              </div>
                            <div class="example-section mb-2" *ngFor="let consent of consentList; let i = index">
                                <mat-checkbox class="example-margin" [formControlName]="i" (change)="updateAllConsentsSelected()">
                                  {{consent.mdTitle}}
                                </mat-checkbox>
                              </div>
                        </section>
                        <div class="text-center mt-4 submit-button">
                            <button class="primary-Button" (click)="submit()" [disabled]="proposalForm.invalid">Submit <i
                                    class="fa-solid fa-arrow-right"></i></button>
                        </div>
                    </form>
                </section>
            </div>

        </div>
    </div>
</section>
